module.exports = __webpack_public_path__ + "low-fbb0ad7a45663b79182d71b3f8b1a408.png";